// extracted by mini-css-extract-plugin
module.exports = {"alert":"r0hiHMu2"};